import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { GoToListPageButtonProps } from '../../../../components/common/buttons/GoToListPageButton';
import { IProduct } from '../../../../interfaces/Product.interfaces';
import { chunkArrayForQuadSwiper } from '../../../../utils/chunkArrayForQuadSwiper.util';
import {
  IProductForPreviewCard,
  IProductPreviewCardListType,
  ProductPreviewCard,
} from '../../listView/ProductPreviewCard/ProductPreviewCard';
import { DetailQuadSwiper } from './DetailQuadSwiper';

interface ProductQuadSwiperGroupProps {
  title?: string;
  products: IProduct[];
  goToButton: GoToListPageButtonProps;
  pageType: IProductPreviewCardListType;
  slideHeight?: number;
}

export const ProductQuadSwiperGroup = ({
  title,
  products,
  goToButton,
  pageType,
  slideHeight,
}: ProductQuadSwiperGroupProps) => {
  const chunkedProducts = chunkArrayForQuadSwiper<IProduct>(products) || [];

  return (
    <DetailQuadSwiper
      title={title}
      slideHeight={slideHeight}
      slideItems={chunkedProducts.map((products, index) => (
        <QuadItemGroup key={products.map((product) => product.id).join('-')}>
          <QuadRow>
            <QuadItem key={products[0].id}>
              <ProductPreviewCard
                product={products[0] as IProductForPreviewCard}
                currentProductForMarketAmpliEvent={{ code: products[0].code }}
                listType={pageType}
                onClick={() => {
                  if (pageType === 'ndp') {
                    ampli.pvmClickNdpPluvaTractors({
                      id: products[0].id,
                      index: index.toString(),
                      price: products[0].price,
                      title: products[0].title,
                    });
                  }
                }}
              />
            </QuadItem>
            <QuadItem key={products[1].id}>
              <ProductPreviewCard
                product={products[1] as IProductForPreviewCard}
                currentProductForMarketAmpliEvent={{ code: products[1].code }}
                listType={pageType}
                onClick={() => {
                  if (pageType === 'ndp') {
                    ampli.pvmClickNdpPluvaTractors({
                      id: products[1].id,
                      index: index.toString(),
                      price: products[1].price,
                      title: products[1].title,
                    });
                  }
                }}
              />
            </QuadItem>
          </QuadRow>
          <QuadRow>
            <QuadItem key={products[2].id}>
              <ProductPreviewCard
                product={products[2] as IProductForPreviewCard}
                currentProductForMarketAmpliEvent={{ code: products[2].code }}
                listType={pageType}
                onClick={() => {
                  if (pageType === 'ndp') {
                    ampli.pvmClickNdpPluvaTractors({
                      id: products[2].id,
                      index: index.toString(),
                      price: products[2].price,
                      title: products[2].title,
                    });
                  }
                }}
              />
            </QuadItem>
            <QuadItem key={products[3].id}>
              <ProductPreviewCard
                product={products[3] as IProductForPreviewCard}
                currentProductForMarketAmpliEvent={{ code: products[3].code }}
                listType={pageType}
                onClick={() => {
                  if (pageType === 'ndp') {
                    ampli.pvmClickNdpPluvaTractors({
                      id: products[3].id,
                      index: index.toString(),
                      price: products[3].price,
                      title: products[3].title,
                    });
                  }
                }}
              />
            </QuadItem>
          </QuadRow>
        </QuadItemGroup>
      ))}
      goToButton={goToButton}
    />
  );
};

const QuadItemGroup = styled.div`
  max-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const QuadRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

const QuadItem = styled.div`
  width: 142px;
`;
